import React, { useState, useEffect } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../@/components/ui/tooltip";

interface HoverTooltipProps {
  content: any;
  children: React.ReactNode;
}

const HoverTooltip: React.FC<HoverTooltipProps> = ({ content, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const handleClickOutside = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    const handleScroll = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("click", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [isOpen]);

  // Handle touch device detection
  const handleTouchStart = () => {
    setIsTouchDevice(true);
  };

  return (
    <TooltipProvider>
      <Tooltip delayDuration={0} open={isOpen}>
        <TooltipTrigger
          asChild
          onClick={(e) => {
            e.stopPropagation(); // Prevent click from bubbling to window
            if (isTouchDevice) {
              e.preventDefault();
              setIsOpen(!isOpen);
            }
          }}
          onTouchStart={handleTouchStart}
          onMouseEnter={() => !isTouchDevice && setIsOpen(true)}
          onMouseLeave={() => !isTouchDevice && setIsOpen(false)}
          onScroll={() => setIsOpen(false)}
        >
          {children}
        </TooltipTrigger>
        <TooltipContent
          className="select-text max-w-[380px]"
          side="top"
          sideOffset={5}
          align="center"
        >
          <p className="break-words">{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default HoverTooltip;
